import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Modal, Button, Col, Row, Container} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone,faStore, faPlusCircle, faMinusCircle} from '@fortawesome/free-solid-svg-icons';
import { agenciesTable, newAgency, setContent, getContent } from '../firebase/content';
import { updateContent } from '../actions/cartAction';
import Editable from './Editable';
import AlertUpdate from './AlertUpdate';

export class Agencies extends Component {
    state = {
        showAlert: false
    }
    handleShowAlert = () => {
        event.preventDefault()
        this.setState({
            showAlert: !this.state.showAlert,
        })
    }
    addNewAgency() {
        let newAgt = newAgency();
        this.props.content[agenciesTable].push(newAgt)
        this.props.updateContent({...this.props.content})
    }

    deleteAgency(index) {
        this.props.content[agenciesTable].splice(index,1)
        this.props.updateContent({...this.props.content})
    }

    onSave() {
        setContent(this.props.content).then(() => {
            // console.log('saved')
            return getContent()
        }).then(content => {
            return this.props.updateContent(content)
        })
    }

    render() {
        let {editable} = this.props
        let {[agenciesTable]: agencies } = this.props.content
        return (
            <Modal
                dialogClassName="agencies-modal"
                show={this.props.isOpen}
                onHide={this.props.onHide}
                editable={editable}
                size="lg"
            >
                <Modal.Body className="agencies_modal_body">
                    <Container className="agencies_modal_body_content">
                    <h1>DANH SÁCH ĐẠI LÝ</h1>
                        <Row>
                        {(agencies || []).map((agency,i) => (
                            <Col xs={12} sm={6} className="agency" key={agency.id}>
                                <Editable editable={editable} object={agency} field="name">
                                    <p><FontAwesomeIcon icon={faStore} className="store-icon"/> {agency.name}</p>
                                </Editable>

                                <Editable editable={editable} object={agency} field="phone">
                                    <p><FontAwesomeIcon icon={faPhone} className="phone-icon"/> {agency.phone}</p>
                                </Editable>
                                {editable ? (
                                    <FontAwesomeIcon icon={faMinusCircle} onClick={() => this.deleteAgency(i)}></FontAwesomeIcon>
                                ) : ''} 
                            </Col>
                        ))}
                        </Row>
                        <p className="modal-body__message">Liên hệ với chúng tôi để được tư vấn và đặt hàng!</p>
                        <Row>
                            {editable ? (<FontAwesomeIcon icon={faPlusCircle} onClick={this.addNewAgency.bind(this)}></FontAwesomeIcon>): ''}
                        </Row>
                    </Container>
                </Modal.Body>
                {editable ? (
                    <Modal.Footer>
                        <Button className="btn btn-small-secondary" onClick={() => {this.onSave();this.handleShowAlert();}}>Save</Button>
                        {this.state.showAlert && <AlertUpdate />}
                    </Modal.Footer>
                ): ''}
            </Modal>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        content: state.content
    }
} 

const mapDispatchToProps = (dispatch) => {
    return {
        updateContent() { dispatch(updateContent(...arguments))}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Agencies)
